export default class EndStageModalCtrl {

	constructor ($scope, $state, $http, $resource, $filter, ngNotify, $mdDialog, WorkPlanSrv, WorkPlanModalSrv, GlobalConfig, Validations, WorkPlanParametrizationSrv, GlobalSrv, $cookies, $stateParams, ReviewSrv) {
		var endStageModalVm = this
		// Variables
		const sharedVar = WorkPlanModalSrv.getVariable()

		endStageModalVm.teacherId = parseInt(sharedVar.teacherId)
		endStageModalVm.workplanId = parseInt(sharedVar.workplanId)
		endStageModalVm.currentUser = $cookies.getObject('currentUser')
		endStageModalVm.userId = sharedVar.userId
		endStageModalVm.textStage = sharedVar.textStage
		endStageModalVm.count = sharedVar.count
		endStageModalVm.toReviewed = sharedVar.toReviewed
		endStageModalVm.allAct = sharedVar.allAct
		endStageModalVm.isReviewAndApproval = sharedVar.isReviewAndApproval
		const currentStage = sharedVar.currentStage
		const currentRoleId = +$cookies.get('hasRoleId')

		endStageModalVm.pendingBreakdown = null
		endStageModalVm.pendingBreakdownLoading = false
		endStageModalVm.hasPendingOther = hasPendingOther
		endStageModalVm.assignedAllApproved = assignedAllApproved

		endStageModalVm.strategic = sharedVar.strategic
		endStageModalVm.statusApproval = 0
		endStageModalVm.approvalCompleted = false
		endStageModalVm.criteriaList = []
		endStageModalVm.criteriaOption = 1
		endStageModalVm.isNotTouchedCriterias = true
		endStageModalVm.toBlocked = 0

		endStageModalVm.inReview = Validations.inReview(currentStage)
		endStageModalVm.inApproval = Validations.inApproval(currentStage)
		endStageModalVm.inExecution = Validations.inExecution(currentStage)
		endStageModalVm.inEvaluation = Validations.inEvaluation(currentStage)
		endStageModalVm.inReviewExecution = Validations.inReviewExecution(currentStage)
		endStageModalVm.integralEvaluationURL = GlobalConfig.externalURLs.integralEvaluationURL

		// methods
		endStageModalVm.close = close
		endStageModalVm.hasError = hasError
		endStageModalVm.showErrorMessages = showErrorMessages
		endStageModalVm.validateForm = validateForm
		endStageModalVm.finish = finish
		endStageModalVm.isToReviewed = isToReviewed
		endStageModalVm.isAllReviewed = isAllReviewed
		endStageModalVm.isShowOption = isShowOption
		endStageModalVm.selectedCriteria = selectedCriteria

		active()

		if (endStageModalVm.inReview || endStageModalVm.inReviewExecution) {
			loadPendingBreakdown()
		}

		function loadPendingBreakdown () {
			const stageId = endStageModalVm.inReview
				? GlobalConfig.workplanIdStages.review
				: GlobalConfig.workplanIdStages.reviewExecution

			const post = {
				teacherId  : endStageModalVm.teacherId,
				workplanId : endStageModalVm.workplanId,
				stageId    : stageId,
				evaluatorId: endStageModalVm.currentUser.id,
				roleId     : currentRoleId,
			}

			endStageModalVm.pendingBreakdownLoading = true

			return ReviewSrv.getPendingActivitiesBySubmodule.post(post).$promise.then((dataReturn) => {
				if (dataReturn && dataReturn.status) {
					endStageModalVm.pendingBreakdown = dataReturn.data
				}
			}).catch((err) => {
				console.log('loadPendingBreakdown error', err)
			}).finally(() => {
				endStageModalVm.pendingBreakdownLoading = false
			})
		}

		function hasPendingOther () {
			return !!(endStageModalVm.pendingBreakdown &&
				endStageModalVm.pendingBreakdown.other &&
				endStageModalVm.pendingBreakdown.other.length > 0)
		}

		function assignedAllApproved () {
			return !!(endStageModalVm.pendingBreakdown &&
				endStageModalVm.pendingBreakdown.assigned &&
				endStageModalVm.pendingBreakdown.assigned.pending === 0)
		}

		function active () {
			if (endStageModalVm.inEvaluation || endStageModalVm.inApproval || endStageModalVm.isReviewAndApproval) {
				if (endStageModalVm.count == 0) {
					endStageModalVm.statusApproval = 1
				} else if (endStageModalVm.count > 0 || endStageModalVm.allAct !== endStageModalVm.count) {
					endStageModalVm.statusApproval = 2
				} else if (endStageModalVm.count > 0) {
					endStageModalVm.statusApproval = 3
				}

				let post = {
					listId    : (endStageModalVm.inApproval || endStageModalVm.isReviewAndApproval) ? 1 : 2,
					workplanId: endStageModalVm.workplanId,
				}
				
				if (endStageModalVm.inReviewExecution || endStageModalVm.inEvaluation) {
					return WorkPlanSrv.getWorkplanEvaluationCriteriaDetail.get(post).$promise.then((dataReturn) => {
						if (dataReturn.status) {
							endStageModalVm.criteriaList = dataReturn.data.list
						}
					}).catch((error) => {
						console.log(error)
					})
				} else {
					return WorkPlanSrv.getCriteriaCategoryDetail.get(post).$promise.then((dataReturn) => {
						if (dataReturn.status) {
							endStageModalVm.criteriaList = dataReturn.data.list
						}
					}).catch((error) => {
						console.log(error)
					})
				}
			}
		}

		function close () {
			WorkPlanModalSrv.setVariable(endStageModalVm.approvalCompleted)

			return $mdDialog.hide()
		}

		function finish () {
			let header = {
				teacherId : endStageModalVm.teacherId,
				workplanId: endStageModalVm.workplanId,
			}

			if (endStageModalVm.inReview && !endStageModalVm.isReviewAndApproval) {
				header.stageId = GlobalConfig.workplanIdStages.review
				header.isReviewed = GlobalConfig.generals.active
				header.comments = endStageModalVm.description
			} else if (endStageModalVm.inApproval) {
				endStageModalVm.toBlocked = getNumOrderCriteria(endStageModalVm.idList)
				header.stageId = GlobalConfig.workplanIdStages.approval

				if (endStageModalVm.toBlocked) {
					endStageModalVm.statusApproval = 0
				}

				header.isApproved = endStageModalVm.statusApproval
				header.comments = endStageModalVm.description
				header.criteriaId = endStageModalVm.idList

				if (header.isApproved > 0) {
					header.isApprovedReject = 0
				} else {
					header.isApprovedReject = 1
				}
			} else if (endStageModalVm.inReview && endStageModalVm.isReviewAndApproval) {
				header.stageId = GlobalConfig.workplanIdStages.review
				header.isReviewed = GlobalConfig.generals.active
				header.comments = endStageModalVm.description
				endStageModalVm.toBlocked = getNumOrderCriteria(endStageModalVm.idList)
				header.reviewAndApprove = endStageModalVm.isReviewAndApproval

				if (endStageModalVm.toBlocked) {
					endStageModalVm.statusApproval = 0
				}

				header.isApproved = endStageModalVm.statusApproval
				header.comments = endStageModalVm.description
				header.criteriaId = endStageModalVm.idList

				if (header.isApproved > 0) {
					header.isApprovedReject = 0
				} else {
					header.isApprovedReject = 1
				}
			} else if (endStageModalVm.inReviewExecution) {
				header.stageId = GlobalConfig.workplanIdStages.reviewExecution
				header.comments = endStageModalVm.description

				if (endStageModalVm.isReviewAndApproval) {
					header.reviewAndApprove = endStageModalVm.isReviewAndApproval
					header.criteriaId = endStageModalVm.idList
					getNumOrderCriteria(endStageModalVm.idList)
				}
			} else if (endStageModalVm.inEvaluation) {
				header.stageId = GlobalConfig.workplanIdStages.evaluation
				header.criteriaId = endStageModalVm.idList
				header.comments = endStageModalVm.description
				getNumOrderCriteria(endStageModalVm.idList)
			}

			if (endStageModalVm.toBlocked) {
				let header2 = {
					id_teacher                 : endStageModalVm.teacherId,
					id_work_plan               : endStageModalVm.workplanId,
					ds_description             : 'Plan de trabajo bloqueado por no aprobación',
					dt_start_date              : moment().format('YYYY-MM-DD'),
					id_list_item_situation_type: 2400,
					id_teacher_type            : '', // TODO se envia null, dado que no lo tenemos y no lo ocupa en el insert
					id_submodule               : '2,3,4,5,6',
					dt_end_date                : '',
					id_user                    : endStageModalVm.currentUser.id,
				}

				toBlock(header2)
			}

			endStage(header) 
		}

		function endStage (header) {
			WorkPlanSrv.endStages.update(header).$promise.then((dataReturn) => {
				if (dataReturn.status) {
					if (endStageModalVm.inReview && !endStageModalVm.isReviewAndApproval) {
						notifyMainEvaluator($stateParams.teacherId, $stateParams.name, GlobalConfig.notificationType.inbox)
						notifyMainEvaluator($stateParams.teacherId, $stateParams.name, GlobalConfig.notificationType.email)
						$state.go('fullscreen.workPlanReview')
					} else if (endStageModalVm.inApproval) {
						if (endStageModalVm.toBlocked == 0) {
							setApprovedCompletedNotify(endStageModalVm.userId)
							setApprovalNotify(endStageModalVm.userId)
							setApprovalNotifyStrategic(endStageModalVm.userId)
							//setGenerateRolNotify(endStageModalVm.userId,endStageModalVm.teacherId)   
						} else {
							setReprovedCompletedNotify(endStageModalVm.userId)
							setSpecialSituationNotify(endStageModalVm.userId)
						}

						$state.go('fullscreen.workPlanApproval')
					} else if (endStageModalVm.inReview && endStageModalVm.isReviewAndApproval) {
						notifyMainEvaluator($stateParams.teacherId, $stateParams.name, GlobalConfig.notificationType.inbox)
						notifyMainEvaluator($stateParams.teacherId, $stateParams.name, GlobalConfig.notificationType.email)

						if (endStageModalVm.toBlocked == 0) {
							setApprovedCompletedNotify(endStageModalVm.userId)
							setApprovalNotify(endStageModalVm.userId)
							setApprovalNotifyStrategic(endStageModalVm.userId)
						} else {
							setReprovedCompletedNotify(endStageModalVm.userId)
							setSpecialSituationNotify(endStageModalVm.userId)
						}

						$state.go('fullscreen.workPlanReview')
					} else if (endStageModalVm.inReviewExecution) {
						if (endStageModalVm.isReviewAndApproval) {
							setEvaluationNotify(endStageModalVm.userId, GlobalConfig.notificationType.inbox)
							setEvaluationNotify(endStageModalVm.userId, GlobalConfig.notificationType.email)
							showEvaluationModal('fullscreen.workPlanReviewExecution')
						} else {
							$state.go('fullscreen.workPlanReviewExecution')
						}
					} else if (endStageModalVm.inEvaluation) {
						setEvaluationNotify(endStageModalVm.userId, GlobalConfig.notificationType.inbox)
						setEvaluationNotify(endStageModalVm.userId, GlobalConfig.notificationType.email)
						showEvaluationModal('fullscreen.workPlanEvaluation')
					}

					endStageModalVm.approvalCompleted = true
					endStageModalVm.close()
				}
			}).catch((error) => {
				const message = error && error.data && error.data.message
					? error.data.message
					: 'No fue posible finalizar la etapa. Revise las condiciones del plan e intente nuevamente.'
				ngNotify.set(message, 'error')
			})
		}

		function showEvaluationModal(state) {
			$mdDialog.show({
				controller: [ '$scope', '$mdDialog', function showEvaluationModal ($scope, $mdDialog) {
					$scope.integralEvaluationURL = endStageModalVm.integralEvaluationURL
					$scope.close = function () {
						$mdDialog.hide()
						$state.go(state)
					}
				} ],
				template           : require('./successEvaluation.html'),
				clickOutsideToClose: false,
			})
		}

		function toBlock (header) {
			WorkPlanSrv.addSpecialSituationTeacher.set(header).$promise.then((dataReturn) => {
				if (dataReturn.status) {
					console.log('llamada a crear una situacion especial')
				}
			})
		}

		function getNumOrderCriteria (criteriaId) {
			let toBlock = 0

			for (var i in endStageModalVm.criteriaList) {
				if (endStageModalVm.criteriaList[i].id_lists_item === criteriaId) {
					endStageModalVm.itemName = endStageModalVm.criteriaList[i].lists_item_name

					if (parseInt(i) === 2) {
						toBlock = 1
						break
					}
				}
			}

			return toBlock
		}

		// forms validations
		function hasError (input) {
			if (input.$invalid && (input.$dirty || input.$touched)) {
				return 'has-error'
			}
		}

		function showErrorMessages (input) {
			return input.$dirty || input.$touched
		}

		function validateForm (form) {
			return form.$invalid
		}

		function isToReviewed () {
			if (endStageModalVm.inApproval || endStageModalVm.inEvaluation || endStageModalVm.inReviewExecution || endStageModalVm.isReviewAndApproval) {
				return endStageModalVm.toReviewed > 0
			} else { return false }
		}

		function isAllReviewed () {
			if (endStageModalVm.inApproval || endStageModalVm.inEvaluation || endStageModalVm.inReviewExecution || endStageModalVm.isReviewAndApproval) {
				return endStageModalVm.toReviewed === 0
			} else {
				return true
			}
		}

		function isShowOption (value) {
			if (endStageModalVm.inApproval) {
				switch (value) {

				case 1:
					return endStageModalVm.count === 0
				case 2:
					return endStageModalVm.count === 0 || endStageModalVm.allAct === endStageModalVm.count
				case 3:
					return endStageModalVm.count > 0
				default:
					return false
				
				}
			} else {
				return false
			}
		}

		function selectedCriteria () {
			if (endStageModalVm.idList > 0) {
				endStageModalVm.isNotTouchedCriterias = false
			}
		}

		function notifyMainEvaluator (idTeacher, teacherName, notificationType) {
			let data = {
				idTeacher                   : idTeacher,
				dsName                      : 'Notificación, revisión finalizada',
				dsDescription               : 'Apreciado Evaluador el revisor ' + $cookies.getObject('currentUser').name + ' finalizó la revisión del plan de trabajo del profesor ' + teacherName,
				idNotification_delivery_type: notificationType,
				is_grouped                  : 0,
			}

			GlobalSrv.sendNotificationToMainEvaluator(data)
		}

		function setEvaluationNotify (idUser, notificationType) {
			let data = {
				idUser                      : idUser,
				dsName                      : 'Notificación, evaluación finalizada',
				dsDescription               : 'Profesor: su plan de trabajo ha sido valorado como ' + endStageModalVm.itemName + ' y fueron registrados los siguientes comentarios: ' + endStageModalVm.description,
				idNotification_delivery_type: notificationType,
				is_grouped                  : 0,
			}

			GlobalSrv.sendNotification(data)
		}

		function setEvaluationNotifyReviewers (idRole) {
			let reviewers = GlobalSrv.getReviewers(idRole)

			reviewers.forEach((reviewer) => {
				getEvaluationNotify(reviewer)
			})
		}

		function getSpecialSituationNotify(idUser, notificationType) {
			return {
				idUser                      : idUser,
				dsName                      : 'Notificación, situación especial',
				dsDescription               : ' Profesor, se le ha creado una situación especial. Debe comunicarse con su administrador para activar su plan de trabajo',
				idNotification_delivery_type: notificationType,
				is_grouped                  : 0,
			}
		}

		function getApprovalNotify(idUser, notificationType) {
			return {
				idUser                      : idUser,
				dsName                      : 'Notificación, aprobación finalizada',
				dsDescription               : 'Profesor, su plan de trabajo ha sido valorado como ' + endStageModalVm.itemName + ' y fueron registrados los siguientes comentarios: ' + endStageModalVm.description + '. Realice los ajustes correspondientes en la ejecución.',
				idNotification_delivery_type: notificationType,
				is_grouped                  : 0,
			}
		}

		function getReprovedNotify(idUser, notificationType) {
			return {
				idUser                      : idUser,
				dsName                      : 'Notificación, aprobación finalizada',
				dsDescription               : 'Profesor: su plan de trabajo ha sido valorado como Reprobado y fueron registrados los siguientes comentarios: ' + endStageModalVm.description,
				idNotification_delivery_type: notificationType,
				is_grouped                  : 0,
			}
		}

		function setApprovedCompletedNotify (idUser) {
			GlobalSrv.sendNotification(getApprovalNotify(idUser, GlobalConfig.notificationType.inbox))
			GlobalSrv.sendNotification(getApprovalNotify(idUser, GlobalConfig.notificationType.email))
		}

		function setSpecialSituationNotify(idUser) {
			GlobalSrv.sendNotification(getSpecialSituationNotify(idUser, GlobalConfig.notificationType.inbox))
			GlobalSrv.sendNotification(getSpecialSituationNotify(idUser, GlobalConfig.notificationType.email))
		}

		function setReprovedCompletedNotify (idUser) {
			GlobalSrv.sendNotification(getReprovedNotify(idUser, GlobalConfig.notificationType.inbox))
			GlobalSrv.sendNotification(getReprovedNotify(idUser, GlobalConfig.notificationType.email))
		}

		function setApprovalNotifyStrategic(idUser) {
			GlobalSrv.sendNotificationToReviewers(getApprovalNotifyStrategic(idUser, GlobalConfig.notificationType.inbox))
			GlobalSrv.sendNotificationToReviewers(getApprovalNotifyStrategic(idUser, GlobalConfig.notificationType.email))
		}

		function setGenerateRolNotify(idUser, idTeacher) {
			WorkPlanSrv.listUserNotify.set({ id_user: idTeacher }).$promise.then((dataReturn) => {
				if (dataReturn.status) {
					var idUsers = []

					for (var i in dataReturn.data) {
						idUsers.push(dataReturn.data[i].id_user)
					}
					idUsers.push(idUser)
					GlobalSrv.sendNotificationToReviewers(getGenerateRolNotify(idUsers, GlobalConfig.notificationType.inbox))
					GlobalSrv.sendNotificationToReviewers(getGenerateRolNotify(idUsers, GlobalConfig.notificationType.email))
					GlobalSrv.sendNotification(getGenerateRolNotify(idUsers, GlobalConfig.notificationType.inbox))
				}
			})
		}

		function getApprovalNotifyCount (idUser) {
			return {
				idUser                      : idUser,
				dsName                      : 'Notificación, aprobación finalizada (actividades reprobadas)',
				dsDescription               : 'Profesor: Su plan de trabajo cuenta con actividades no aprobadas por su jefe',
				idNotification_delivery_type: GlobalConfig.notificationType.inbox,
				is_grouped                  : 1,
			}
		}

		function getApprovalNotifyStrategic (idUser, notificationType) {
			return {
				idUser                      : idUser,
				dsName                      : 'Notificación, aprobación finalizada (actividades seguimiento estratégico)',
				dsDescription               : 'Algunas actividades del plan de trabajo del profesor ' + sharedVar.teacherName + ' se han enviado al módulo de seguimiento estratégico',
				idNotification_delivery_type: notificationType,
				is_grouped                  : 1,
			}
		}

		function getGenerateRolNotify (idUser, notificationType) {
			return {
				idUser                      : idUser,
				dsName                      : 'Notificación, creación de Rol.',
				dsDescription               : 'El profesor ' + sharedVar.teacherName + ' ha creado un rol durante la planeacion de su plan de trabajo.',
				idNotification_delivery_type: notificationType,
				is_grouped                  : 1,
			}
		}

		function setApprovalNotify (idUser) {
			if (endStageModalVm.inApproval && endStageModalVm.count > 0) {
				GlobalSrv.sendNotification(getApprovalNotifyCount(idUser))
			}

			if (endStageModalVm.inApproval && endStageModalVm.strategic > 0) {
				GlobalSrv.sendNotification(getApprovalNotifyStrategic(idUser, GlobalConfig.notificationType.inbox))
				GlobalSrv.sendNotification(getApprovalNotifyStrategic(idUser, GlobalConfig.notificationType.email))
			}
		}
	}

}

EndStageModalCtrl.$inject = [ '$scope', '$state', '$http', '$resource', '$filter', 'ngNotify',
	'$mdDialog', 'WorkPlanSrv', 'WorkPlanModalSrv', 'GlobalConfig', 'Validations',
	'WorkPlanParametrizationSrv', 'GlobalSrv', '$cookies', '$stateParams', 'ReviewSrv' ]



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/partials/review/summary/modals/endStageModalCtrl.js